import { render, staticRenderFns } from "./WideHeaderSearch.vue?vue&type=template&id=65b1d132&scoped=true&"
import script from "./WideHeaderSearch.vue?vue&type=script&lang=js&"
export * from "./WideHeaderSearch.vue?vue&type=script&lang=js&"
import style0 from "./WideHeaderSearch.vue?vue&type=style&index=0&id=65b1d132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b1d132",
  null
  
)

export default component.exports